import * as React from 'react';

export default () => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
        >
          <path d="M1.455 2.91H0v11.636C0 15.349.65 16 1.455 16H13.09v-1.454H1.455V2.909z"></path>
          <path d="M14.546 0H4.364C3.56 0 2.909.65 2.909 1.455v10.181c0 .804.651 1.455 1.455 1.455h10.181c.804 0 1.455-.651 1.455-1.455V1.455C16 .65 15.35 0 14.546 0zm0 11.636H4.364V1.455h10.181v10.181z"></path>
        </svg>
    );
}